import React from "react"

export const FileDocument = ({ height = 64, width = 54, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 54 64" fill="none" {...props}>
    <path d="M53.3527 58.6154L7.94662 63.8234L1.30078 5.88155L45.4819 0.814042L53.3527 58.6154Z" fill="#000066" />
    <path d="M0 5.34835L45.4061 0.140336L52.0519 58.0822L6.64584 63.2902L0 5.34835Z" fill="white" />
    <path d="M7.04688 10.1433L39.6315 6.40586L39.6603 6.65673L7.07565 10.3941L7.04688 10.1433Z" fill="#1D72F4" />
    <path d="M7.95312 18.0446L40.5377 14.3072L40.5665 14.5581L7.9819 18.2955L7.95312 18.0446Z" fill="#1D72F4" />
    <path d="M8.85938 25.946L41.444 22.2086L41.4728 22.4595L8.88815 26.1969L8.85938 25.946Z" fill="#1D72F4" />
    <path d="M9.76562 33.8464L42.3502 30.109L42.379 30.3599L9.7944 34.0973L9.76562 33.8464Z" fill="#1D72F4" />
    <path d="M10.6719 41.7478L43.2565 38.0104L43.2853 38.2612L10.7006 41.9986L10.6719 41.7478Z" fill="#1D72F4" />
    <path d="M11.5781 49.6491L44.1627 45.9117L44.1915 46.1626L11.6069 49.9L11.5781 49.6491Z" fill="#1D72F4" />
    <path
      d="M4.01205 8.90447C4.70535 8.82495 5.20291 8.19846 5.12339 7.50516C5.04387 6.81186 4.41738 6.3143 3.72408 6.39382C3.03078 6.47334 2.53321 7.09983 2.61273 7.79313C2.69225 8.48643 3.31875 8.98399 4.01205 8.90447Z"
      fill="#000066"
    />
    <path
      d="M42.766 4.46014C43.4593 4.38062 43.9568 3.75412 43.8773 3.06082C43.7978 2.36753 43.1713 1.86996 42.478 1.94948C41.7847 2.029 41.2871 2.65549 41.3666 3.34879C41.4462 4.04209 42.0727 4.53966 42.766 4.46014Z"
      fill="#000066"
    />
  </svg>
)
